/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */
import type { App } from 'vue'
import VueCookies from 'vue-cookies'
import store from '@/store/index.ts'
import router from '@/router'
import { BaseService } from '@/modules/Core/services/BaseService.js'

//layout componentes
import OffSetDefault from '@/modules/Core/components/Layout/OffSetDefault.vue'
import ModalDefault from '@/modules/Core/components/Layout/ModalDefault.vue'
import CrudBasic from '@/modules/Core/components/Layout/CrudBasic.vue'
import DetailsPatient from '@/modules/Core/components/Layout/DetailsPatient.vue'
//form componentes
import Codemirror from '@/modules/Core/components/Form/CodemirrorDefault.vue'
import SelectAvanced from '@/modules/Core/components/Form/SelectAvanced.vue'
import ButtonTeleporter from '@/modules/Core/components/Layout/ButtonTeleporter.vue'
import PatientInfoCard from '@/modules/Core/components/general/PatientInfoCard.vue'
import Historial from '@/modules/Asistencial/components/HistorialInfo.vue'
import SelectDefault from '@/modules/Core/components/Form/SelectDefault.vue'
import SelectSearch from '@/modules/Core/components/Form/SelectSearch.vue'
import InputDefault from '@/modules/Core/components/Form/InputDefault.vue'
import InputCombo from '@/modules/Core/components/Form/InputCombo.vue'
import FileInputDefault from '@/modules/Core/components/Form/FileInputDefault.vue'
import SwitchDefault from '@/modules/Core/components/Form/SwitchDefault.vue'
import TextareaDefault from '@/modules/Core/components/Form/TextareaDefault.vue'
import ColorPickerDefault from '@/modules/Core/components/Form/ColorPickerDefault.vue'
import DatePickerDefault from '@/modules/Core/components/Form/DatePickerDefault.vue'
import DatePickerRangeDefault from '@/modules/Core/components/Form/DatePickerRangeDefault.vue'
import PrelineSelect from '@preline/select'
import PrelineCombobox from '@preline/combobox'
import PatientListDefault from '@/modules/Core/components/Form/PatientListDefault.vue'
import TimePickerDefault from '@/modules/Core/components/Form/TimePickerDefault.vue'
//general componentes
import MdiIcon from '@/modules/Core/components/general/MdiIcon.vue'
import TooltipDefault from '@/modules/Core/components/general/TooltipDefault.vue'
import ButtonDefault from '@/modules/Core/components/general/ButtonDefault.vue'
import TabsDefault from '@/modules/Core/components/general/TabsDefault.vue'
import ButtonBase from '@/modules/Core/components/general/ButtonBase.vue'
import Filters from '@/modules/Core/components/DataTable/DataTableFilters.vue'
import DataTablePagination from '@/modules/Core/components/DataTable/DataTablePagination.vue'
import DataTable from '@/modules/Core/components/DataTable/DataTable.vue'
import DataTableStyled from '@/modules/Core/components/DataTable/DataTableStyled.vue'
import StatsSimple from '@/modules/Core/components/general/StatsSimple.vue'
import SimpleSkeleton from '@/modules/Core/components/general/SimpleSkeleton.vue'
import Alert from '@/modules/Core/components/general/AlertDefault.vue'
import ToastLoader from '@/modules/Core/components/general/ToastLoader.vue'
import RawDisplayer from '@/modules/Core/components/general/RawDisplayer.vue'
import SvgIcon from '@/modules/Core/components/general/svg-icon.vue'
import CardFormularioTable from '@/modules/Configuracion/components/Formularios/CardFormularioTable.vue'
import ComponentForm from '@/modules/Core/components/Form/ComponentForm.vue'
import ErrorTag from '@/modules/Core/components/Form/ErrorTag.vue'
import IconErrorTag from '@/modules/Core/components/Form/IconErrorTag.vue'
import ComponentViewForm from '@/modules/Asistencial/components/ComponentViewForm.vue'
import VueDatePicker from '@vuepic/vue-datepicker'
import AccordionDefault from '@/modules/Core/components/general/AccordionDefault.vue'
import PopoverDefault from '@/modules/Core/components/general/PopoverDefault.vue'
import SeleccionEntidades from '@/modules/Core/components/general/SeleccionEntidades.vue'
import ButtonGroup from '@/modules/Core/components/general/ButtonGroup.vue';
import SpinnerDefault from '@/modules/Core/components/general/SpinnerDefault.vue';
//imports
import axios from 'axios'
import notificacion from '@/modules/Core/utils/notificaciones.js'
import { appendLeadingZeroes } from '@/modules/Core/usings/generales.js'
import '@vuepic/vue-datepicker/dist/main.css'

let pluginsRegistered = false

export function registerPlugins(app: App) {
  if (pluginsRegistered) return // Evita registrar más de una vez
  pluginsRegistered = true

  //layout componentes
  app.component('ModalDefault', ModalDefault)
  app.component('OffSetDefault', OffSetDefault)
  app.component('CrudBasic', CrudBasic)
  app.component('DetailsPatient', DetailsPatient)

  //form componentes
  app.component('TextCodemirror', Codemirror)
  app.component('SwitchDefault', SwitchDefault)
  app.component('TextareaDefault', TextareaDefault)
  app.component('InputCombo', InputCombo)
  app.component('InputDefault', InputDefault)
  app.component('FileInputDefault', FileInputDefault)
  app.component('ColorPickerDefault', ColorPickerDefault)
  app.component('DatePickerDefault', DatePickerDefault)
  app.component('PatientInfoCard', PatientInfoCard)
  app.component('HistorialInfo', Historial)
  app.component('DatePickerRangeDefault', DatePickerRangeDefault)
  app.component('SelectDefault', SelectDefault)
  app.component('SelectSearch', SelectSearch)
  app.component('SelectAvanced', SelectAvanced)
  app.component('ButtonTeleporter', ButtonTeleporter)
  app.component('PrelineSelect', PrelineSelect)
  app.component('PrelineCombobox', PrelineCombobox)
  app.component('PatientListDefault', PatientListDefault)
  app.component('TimePickerDefault', TimePickerDefault)
  app.component('VueDatePicker', VueDatePicker)

  //general componentes
  app.component('MdiIcon', MdiIcon)
  app.component('TooltipDefault', TooltipDefault)
  app.component('SvgIcon', SvgIcon)
  app.component('ButtonBase', ButtonBase)
  app.component('ButtonDefault', ButtonDefault)
  app.component('TabsDefault', TabsDefault)
  app.component('DataTableFilters', Filters)
  app.component('DataTablePagination', DataTablePagination)
  app.component('DataTable', DataTable)
  app.component('DataTableStyled', DataTableStyled)
  app.component('StatsSimple', StatsSimple)
  app.component('SimpleSkeleton', SimpleSkeleton)
  app.component('AlertDefault', Alert)
  app.component('ToastLoader', ToastLoader)
  app.component('RawDisplayer', RawDisplayer)
  app.component('CardFormularioTable', CardFormularioTable)
  app.component('ErrorTag', ErrorTag)
  app.component('IconErrorTag', IconErrorTag)
  app.component('ComponentForm', ComponentForm)
  app.component('ComponentViewForm', ComponentViewForm)
  app.component('AccordionDefault', AccordionDefault)
  app.component('PopoverDefault', PopoverDefault)
  app.component('SeleccionEntidades', SeleccionEntidades)
  app.component('ButtonGroup', ButtonGroup)
  app.component('SpinnerDefault', SpinnerDefault)
  app.use(VueCookies, { expires: '1d' })
  app.use(router)
  app.use(store)
  app.use(notificacion)
  window['notificacion'] = app.config.globalProperties.$notificacion
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
  axios.defaults.timeout = 7200000
  BaseService.configureDependencies(
    router,
    app.config.globalProperties.$cookies
  )
}

declare global {
  interface Date {
    yyyymmdd(): string
    yyyymmddhhmm(): string
    hhmm(): string
    addDays(days: number): Date
  }
}
Date.prototype.yyyymmddhhmm = function (): string {
  const utcDate = this.toLocaleDateString()
  const utcTime = this.toTimeString().slice(0, 5)

  return (
    utcDate.split('/')[2] +
    '-' +
    appendLeadingZeroes(parseInt(utcDate.split('/')[1])) +
    '-' +
    appendLeadingZeroes(parseInt(utcDate.split('/')[0])) +
    ' ' +
    utcTime
  )
}
Date.prototype.yyyymmdd = function (): string {
  const utc = this.toLocaleDateString()
  return (
    utc.split('/')[2] +
    '-' +
    appendLeadingZeroes(parseInt(utc.split('/')[1])) +
    '-' +
    appendLeadingZeroes(parseInt(utc.split('/')[0]))
  )
}
Date.prototype.hhmm = function () {
  return (
    this.getHours() -
    (this.getHours() > 12 ? 12 : 0) +
    ':' +
    appendLeadingZeroes(this.getMinutes()) +
    (this.getHours() > 11 ? ' PM' : ' AM')
  )
}
Date.prototype.addDays = function (days: number) {
  const date = new Date(this.valueOf())
  date.setDate(date.getDate() + days)
  return date
}
